import { makeScheduler } from "./store-removal-strategies.js";
import { WatchableValue } from "./watchable-value.js";
export class PrimitiveValueState {
    #name;
    #value;
    #unscheduleRemoval = () => { };
    constructor({ name, initialValue, removalSchedule }, removeFromStore, defaultRemovalSchedule) {
        this.#name = name;
        const { schedule: scheduleRemoval, unschedule: unscheduleRemoval } = makeScheduler(removalSchedule ?? defaultRemovalSchedule, () => {
            removeFromStore();
        });
        this.#value = new WatchableValue(initialValue, () => {
            scheduleRemoval();
        }, name);
        this.#unscheduleRemoval = unscheduleRemoval;
    }
    get current() {
        return this.#value.current;
    }
    get name() {
        return this.#name;
    }
    set = (newValue) => {
        this.#value.set(newValue);
    };
    subscribe(listener) {
        this.#unscheduleRemoval();
        return this.#value.subscribe(listener);
    }
}
//# sourceMappingURL=primitive-value.js.map